const STORAGE_KEY = 'wabunka-ai-chat-session-id';

/**
 * チャットセッションID管理
 * localStorage にセッションIDを保存し、リロード後も同一セッションを維持する
 */
export const useChatSession = () => {
  const sessionId = ref<string>('');

  onMounted(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      sessionId.value = stored;
    } else {
      const newId = crypto.randomUUID();
      localStorage.setItem(STORAGE_KEY, newId);
      sessionId.value = newId;
    }
  });

  const resetSession = () => {
    const newId = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, newId);
    sessionId.value = newId;
  };

  return {
    sessionId: readonly(sessionId),
    resetSession,
  };
};
